export default __webpack_public_path__ + "static/media/QuestionBox.1d157cea.svg";